export default __webpack_public_path__ + "static/Wojcik-1da03aace2aa8cc77eaa0ad592eb4b78.jpg";